import React, { useEffect, useState } from 'react'

import { Text } from '@wartek-id/text-v1'
import {
  Dialog,
  DialogCloseButton,
  DialogContent,
  DialogHeader,
  DialogOverlay,
} from '@wartek-id/dialog-v1'

const ALLOW_TENTANG_GNN_KEY = 'ALLOW_TENTANG_GNN'

export const showTentangGnnDialog = () => {
  if (typeof window !== 'undefined') {
    try {
      window.sessionStorage.setItem(ALLOW_TENTANG_GNN_KEY, '1')
    } catch {}
    // Notify the dialog component in this tab to open immediately
    window.dispatchEvent(new Event('about-gnn-open'))
  }
}

const AboutGNNDialog = () => {
  const [show, setShow] = useState(false)

  useEffect(() => {
    const openIfAllowed = () => {
      if (typeof window === 'undefined') return
      try {
        const allowed =
          window.sessionStorage.getItem(ALLOW_TENTANG_GNN_KEY) === '1'
        setShow(!!allowed)
      } catch {
        setShow(false)
      }
    }

    // Open on first mount if allowed
    openIfAllowed()

    // Listen for programmatic open requests
    const onOpen = () => setShow(true)
    window.addEventListener('about-gnn-open', onOpen)

    return () => {
      window.removeEventListener('about-gnn-open', onOpen)
    }
  }, [])

  const handleClose = () => {
    if (typeof window !== 'undefined') {
      try {
        window.sessionStorage.removeItem(ALLOW_TENTANG_GNN_KEY)
      } catch {}
    }
    setShow(false)
  }

  return (
    <Dialog size="lg" type="modal" isOpen={show} onClose={handleClose}>
      <DialogOverlay />
      <DialogContent>
        <DialogHeader>
          <Text as="h2" variant="display-sm">
            Mengenal Gerakan Numerasi Nasional (GNN)
          </Text>
        </DialogHeader>

        <div className="p-6 space-y-4 overflow-auto max-h-[350px] md:max-h-[480px]">
          <div>
            <Text as="h3" variant="heading-lg" className="mb-2">
              Tentang GNN
            </Text>
            <Text>
              Gerakan Numerasi Nasional (GNN) merupakan upaya untuk mendukung
              peningkatan numerasi peserta didik. Di tahap awal, kegiatan akan
              fokus pada siswa di tingkat PAUD dan SD. Dalam pelaksanaan
              kegiatan, program ini melibatkan para pemangku kepentingan, mulai
              dari, guru, keluarga, masyarakat serta komunitas. GNN mengajak
              semua kalangan untuk menjadikan numerasi sebagai bagian dari
              kehidupan sehari-hari. Gerakan ini adalah semangat bersama untuk
              membangun bangsa dengan menumbuhkan budaya berpikir kritis, logis,
              dan analitis di berbagai lapisan masyarakat.
            </Text>
          </div>

          <div>
            <Text as="h3" variant="heading-lg" className="mb-2">
              Latar Belakang
            </Text>
            <Text>
              Kemampuan numerasi atau penggunaan angka dan simbol matematika
              dalam kehidupan sehari - hari menjadi bekal penting bagi individu
              dalam menghadapi berbagai tantangan di kehidupan nyata mulai dari
              mengelola keuangan, membaca grafik informasi, melakukan prediksi
              yang berdasarkan pemikiran logis, hingga mengambil keputusan
              secara rasional. Sayangnya, hasil studi internasional PISA 2022
              menunjukkan skor Matematika anak Indonesia masih rendah, yaitu
              366, berada di peringkat ke-68 dari 81 negara. Selain itu,
              berdasarkan rapor pendidikan tahun 2022 skor numerasi masih pada
              kategori sedang dengan rata-rata 40% di semua jenjang.
            </Text>
            <Text className="mt-2">
              Oleh karena itu, diperlukan adanya Gerakan Numerasi Nasional (GNN)
              sebagai pendukung peningkatan numerasi peserta didik yang
              melibatkan para pemangku kepentingan, sekolah, guru, keluarga,
              masyarakat serta mitra pembangunan guna menciptakan pembelajaran
              yang lebih efektif, mudah dipahami, inklusif, dan menyenangkan.
            </Text>
          </div>

          <div>
            <Text as="h3" variant="heading-lg" className="mb-2">
              Tujuan
            </Text>
            <ul className="list-disc pl-6 space-y-1">
              <li>
                <Text>
                  Menekankan pentingnya numerasi sebagai kemampuan dasar yang
                  dibutuhkan dalam kehidupan sehari-hari.
                </Text>
              </li>
              <li>
                <Text>
                  Meningkatkan kemampuan pendidik dalam mengembangkan pola pikir
                  bertumbuh/berkembang (growth mindset) dari peserta didik,
                  khususnya terkait numerasi.
                </Text>
              </li>
              <li>
                <Text>
                  Meningkatkan kemampuan pendidik dalam strategi pembelajaran
                  numerasi.
                </Text>
              </li>
              <li>
                <Text>
                  Membangun kapasitas kepala sekolah dalam memfasilitasi program
                  numerasi sekolah.
                </Text>
              </li>
              <li>
                <Text>
                  Menyediakan sumber referensi dan ide bagi keluarga dan
                  pendidik untuk membelajarkan numerasi.
                </Text>
              </li>
            </ul>
          </div>
        </div>

        <DialogCloseButton />
      </DialogContent>
    </Dialog>
  )
}

export default AboutGNNDialog
